import React from 'react';

import {
  Create,
  SimpleForm,
  useNotify,
  useRedirect,
} from 'react-admin';

import {
  Grid,
} from '@mui/material';

import useRule from '../../hooks/useRule';

import cleaner from '../../utilities/dataProvider/cleaner';
import ruleTypeMapper from './ruleTypeMapper';

const RuleCreate = () => {
  const {
    ruleType,
    view,
    parentRule,
  } = useRule();

  const redirect = useRedirect();
  const notify = useNotify();

  return (
    <Create
      mutationOptions={{
        onSuccess: () => {
          notify('Rule created');
          redirect('list', 'rules', undefined, {}, { record: { ruleType, view, version: 'draft' } });
        },
      }}
      transform={cleaner}
      record={{ ruleType, parentRule }}
    >
      <SimpleForm mode="all" toolbar={false}>
        <Grid container spacing={1}>
          <Grid size={12}>
            {React.createElement(ruleTypeMapper[ruleType])}
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};

export default RuleCreate;
